<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        
        <span class="ml-12">I CAN &copy; {{ new Date().getFullYear() }} </span>
        
        <span class="md:flex hidden items-center">
            
            <feather-icon icon="MapPinIcon" svgClasses="stroke-current text-primary w-6 h-6"  />
            <span class="ml-2">Rte. de Tunis km6, Sakiet Ezzit 3021, Sfax, Tunisie</span>
        </span>
        <span class="md:flex hidden items-center mr-12">
            <feather-icon icon="PhoneIcon" svgClasses="stroke-current text-success w-6 h-6"  />
            <span class="ml-2">+216 29 222 465</span>
        </span>
        <span class="md:flex hidden items-center mr-12">
            <feather-icon icon="FacebookIcon" svgClasses="stroke-current text-primary w-6 h-6"  />
            <span class="ml-2"><a href="https://www.facebook.com/3mconsultancy/" target="_blank" rel="nofollow">3mconsultancy</a></span>
        </span>
        <!-- buyNow component -->
    </footer>    
</template>

<script>
import BuyNow from '../../components/BuyNow.vue'

export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    },
    inject: {
      components:{
          default: {
            BuyNow
          }
      }
    }
}
</script>
